import { Link, useLocation } from "react-router-dom";
import { Home, Search, Heart, ShoppingBag } from "lucide-react";
import { useCart } from "@/context/CartContext";
import { useWishlist } from "@/context/WishlistContext";

export const MobileBottomNav = () => {
  const { count, setOpen } = useCart();
  const { count: wishCount } = useWishlist();
  const { pathname } = useLocation();
  const active = (p) => (pathname === p ? "text-[#1A1A1A]" : "text-[#737373]");

  return (
    <nav className="md:hidden fixed bottom-0 left-0 right-0 z-40 bg-white/95 backdrop-blur-xl border-t border-[#E5E5E5]" data-testid="mobile-bottom-nav">
      <div className="grid grid-cols-4 h-16">
        <Link to="/" className={`flex flex-col items-center justify-center gap-1 ${active("/")}`} data-testid="bottom-nav-home">
          <Home strokeWidth={1} className="h-5 w-5" />
          <span className="text-[10px] uppercase tracking-wider">Home</span>
        </Link>
        <Link to="/collection/all" className={`flex flex-col items-center justify-center gap-1 ${active("/collection/all")}`} data-testid="bottom-nav-shop">
          <Search strokeWidth={1} className="h-5 w-5" />
          <span className="text-[10px] uppercase tracking-wider">Shop</span>
        </Link>
        <Link to="/wishlist" className={`relative flex flex-col items-center justify-center gap-1 ${active("/wishlist")}`} data-testid="bottom-nav-wishlist">
          <Heart strokeWidth={1} className="h-5 w-5" />
          {wishCount > 0 && <span className="absolute top-2 right-6 h-4 w-4 grid place-items-center rounded-full bg-[#1A1A1A] text-white text-[9px]">{wishCount}</span>}
          <span className="text-[10px] uppercase tracking-wider">Wishlist</span>
        </Link>
        <button onClick={() => setOpen(true)} className="relative flex flex-col items-center justify-center gap-1 text-[#737373]" data-testid="bottom-nav-cart">
          <ShoppingBag strokeWidth={1} className="h-5 w-5" />
          {count > 0 && <span className="absolute top-2 right-6 h-4 w-4 grid place-items-center rounded-full bg-[#1A1A1A] text-white text-[9px]">{count}</span>}
          <span className="text-[10px] uppercase tracking-wider">Bag</span>
        </button>
      </div>
    </nav>
  );
};

export default MobileBottomNav;
